import styled from '@emotion/styled';
import { Space } from 'antd';

export const SadaFieldListButtons = styled(Space)``;
